import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/spots/gardur-lighthouse-hero-thumb.webp")